import React from 'react';

import { LoadingBar } from '../LoadingBar';
import { Spinner } from '../Spinner';

import * as S from './progressBar.styles';
import { ProgressBarProps } from './progressBar.types';

function formatSize(bytes: number) {
  if (Math.abs(bytes) < 1000) {
    return bytes + ' B';
  }
  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let unitIndex = -1;
  do {
    bytes /= 1000;
    ++unitIndex;
  } while (Math.round(Math.abs(bytes) * 100) / 100 >= 1000 && unitIndex < units.length - 1);
  return `${bytes.toFixed(2)} ${units[unitIndex]}`;
}

function formatTime(seconds: number) {
  const remainingHours = Math.floor(seconds / (60 * 60));
  const remainingMinutes = Math.floor((seconds - remainingHours * 60 * 60) / 60);
  const remainingSeconds = Math.round(seconds - remainingHours * 60 * 60 - remainingMinutes * 60);
  const hours =
    remainingHours === 0 ? '00h ' : `${remainingHours < 10 ? '0' : ''}${remainingHours}h `;
  const mins =
    remainingHours === 0 && remainingMinutes === 0
      ? '00m '
      : `${remainingMinutes < 10 ? '0' : ''}${remainingMinutes}m `;
  return `(${hours}${mins}${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}s Left)`;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  filled,
  total,
  timeLeft,
  message,
  isDetailedProgressTextActive = false,
  isBasic = false,
  statusColor,
  showLoadingIcon = false,
}) => {
  const filledPercent = (filled / total) * 100;

  if (!timeLeft) {
    timeLeft = total - filled;
  }

  if (isBasic) return <LoadingBar percentage={filledPercent} />;

  return (
    <S.Container>
      <S.Row>
        <S.Message>{message}</S.Message>
        {showLoadingIcon && <Spinner type="orbit" />}
      </S.Row>
      <LoadingBar percentage={filledPercent} />
      <S.ProgressInfoContainer>
        {isDetailedProgressTextActive ? (
          <S.ProgressLabelContainer>
            <S.ProgressLabel statusColor={statusColor}>{formatSize(filled)} /</S.ProgressLabel>
            <S.ProgressLabel statusColor={statusColor}>{formatSize(total)}</S.ProgressLabel>
            <S.ProgressLabel statusColor={statusColor}>{formatTime(timeLeft)}</S.ProgressLabel>
          </S.ProgressLabelContainer>
        ) : (
          <S.ProgressLabel statusColor={statusColor}>{filledPercent.toFixed(2)}%</S.ProgressLabel>
        )}
      </S.ProgressInfoContainer>
    </S.Container>
  );
};

export { ProgressBar };
